<template>
    <section class="section-one">
      <div class="section-one__title">LA TUA MOTO</div>
      <div class="section-one--container">
        <div class="content-container container__one">
          <span class="title-bold-one">Prezzo di mercato</span>
          <span class="price-bold">{{ formatNumber(auto.prezzo_mercato) }} €</span>
        </div>
        <!-- Temporaneamente nascosti: riabilitare quando definita la formula di calcolo
        <div class="content-container container__two">
          <span class="title-bold-one">Tempo medio per la vendita</span>
          <span class="text-one"><b>{{ auto.giorni_vendita }} giorni</b></span>
        </div>
        <div class="content-container container__three">
          <span class="title-bold-one">Svalutazione a 90 giorni</span>
          <span class="text-one"><b>{{ formatNumber(auto.deprezzamento) }} €</b></span>
        </div>
        <div class="content-container container__four">
          <span class="title-bold-one">Margine di negoziazione</span>
          <span class="text-one"><b>{{ formatPercent(auto.margine_negoziazione) }}%</b></span>
        </div>
        -->
      </div>
    </section>
</template>

<script>
export default {
  name: 'LivemarketDataYourCar',
  props: {
    auto: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      // Arrotonda decimali API (punto = virgola) a intero, poi migliaia IT
      const n = Math.round(Number(String(value).replace(',', '.')));
      if (Number.isNaN(n)) {
        return '';
      }
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const n = Number(String(value).replace(',', '.'));
      if (Number.isNaN(n)) {
        return '';
      }
      return n.toLocaleString('it-IT', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    toNumber(value) {
      return Number(value.replace(',', '.'));
    }
  },
}
</script>


<style scoped>
.section-one {
  display: flex;
  padding: 65px 0px 58px;
  margin: 0px 100px;
  border-top: 2px solid #d20a11;
  position: relative;
}
.section-one__title {
  color: #ffffff;
  background-color: #d20a11;
  padding: 0px 25px;
  height: 33px;
  position: absolute;
  top: 0;
  left: 40.5%;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
  line-height: 56px;
  letter-spacing: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-bold-one {
  font-size: 0.875rem;
  line-height: 18px;
  font-weight: bold;
  text-align: center;
}
.price-bold {
  font-size: 47px;
  line-height: 62px;
  color: #d20a11;
  font-weight: bold;
  margin-top: 20px;
}

.section-one--container {
  display: flex;
  width: 100%;
  align-items: center;
  max-width: 830px;
  margin: auto;
}
.content-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container__one {
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-right: 15px;
  padding: 20px;
}

.container__two {
  width: 152px;
  height: 95px;
  border-right: 1px solid #cccccc;
}

.container__two .title-bold-one {
  width: 60%;
}

.container__three {
  width: 152px;
  height: 95px;
  border-right: 1px solid #cccccc;
}

.container__three .title-bold-one {
  width: 50%;
}

.container__four {
  width: 152px;
  height: 95px;
}

.container__four .title-bold-one {
  width: 50%;
}
.text-one {
  font-size: 28px;
  line-height: 48px;
  letter-spacing: 0px;
  color: #d20a11;
  margin-top: 8px;
  font-weight: 300;
}

@media (max-width: 768px) {
    .section-one, .section-five {
        padding: 40px 0px;
        margin: 0px 17px;
    }
    .section-one--container {
        flex-direction: column;
    }
    .container__one {
        margin-right: 0px;
        width: 100%;
        margin-top: 16px;
    }
    .container__two {
        width: 100%;
        height: inherit;
        border-right: inherit;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        padding-bottom: 9px;
    }
    .title-bold-one {
        width: auto;
        margin-top: 5px;
    }
    .container__three {
        width: 100%;
        height: inherit;
        border-right: inherit;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        padding-bottom: 9px;
    }
    .container__four {
        width: 100%;
        height: inherit;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        padding-bottom: 9px;
    }
}
@media (max-width: 414px) {
    .section-one__title {
        left: 24.5%;
    }
    .price-bold {
    display: flex;
    gap:10px;
}
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataYourCar.vue